export default "__VITE_ASSET__D8aJGIwI__"